module.exports = __webpack_public_path__ + "static/media/ro.83f16cfe.svg";